/**
 * Combine portrait and landscape components into one
 * Defaults to 'portrait'
 */

import 'components/carousels/JsCarousel.js';
import {
    SwiperCarouselPortraitBreakpoints,
    SwiperCarouselLandsCapeBreakpoints,
} from 'components/settings/BreakpointSettings';

export default function (customOptions = {}) {
    // orientations are 'landscape' or 'portrait' (default)
    let orientation = customOptions.orientation ? customOptions.orientation : 'portrait';

    let wrapper = customOptions.parentContainer
        ? customOptions.parentContainer
        : $('.generic-carousel');

    let defaultOptions = {
        responsive:
            orientation == 'portrait'
                ? SwiperCarouselPortraitBreakpoints
                : SwiperCarouselLandsCapeBreakpoints,
    };

    let endOptions = $.extend(defaultOptions, customOptions.options);

    wrapper.JsCarousel(endOptions);
    return wrapper;
}
